import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid2,
  Typography,
} from "@mui/material";

import { PrimaryFormLoadingActionButton } from "../../../Features/Table/GenericDraggableTable/TableStyles";
import PreviewChart from "./PreviewChart";
import ZoomResetView from "../../DigitalTwinV3/components/ZoomResetView";
import EntityIdDisplayBox from "../Common/EntityIdDisplayBox";

const VisualizationPreview = ({
  chartId,
  selectedDate,
  chartData,
  onSave,
  isEdit = false,
  isLoading = false,
  onZoom = () => {},
  onZoomReset = () => {},
  zoomedRange = null,
  setLoading = null,
  isZoomed = false,
  annotationData = [],
  batteryInfo = {},
  selectedEntity = null
}) => {
  const {series = [], metrics = []} = chartData;
  const [isSaveDisabled, setIsSaveDisabled] = useState(series.length <= 0);
  const zoomResetViewRef = useRef(null);

  useEffect(() => {
    const {series = []} = chartData;
    setIsSaveDisabled(series.length <= 0)
  }, [chartData])

  return (
    <Box sx={{ width: '350px', height: '605px', flex: 1, borderRadius: '12px', backgroundColor: '#FFFFFF', p: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
      <Box>
        <Grid2 container justifyContent={'space-between'}>
          <Typography variant="fw500s16c000000" sx={{lineHeight: '28px'}}>Preview</Typography>
          <Grid2 container justifyContent={'flex-end'} alignItems={'center'} gap={1} sx={{ width: 'auto' }}>
            <EntityIdDisplayBox selectedEntity={selectedEntity} batteryInfo={batteryInfo} />
            <ZoomResetView
              ref={zoomResetViewRef}
              chartID={chartId}
              containerStyles={{mr: 0}}
              iconButtonStyles={{py: 0.5, width: '28px', height: '28px'}}
              onReset={onZoomReset}
              isZoomedProp={isZoomed}
            />
          </Grid2>
        </Grid2>
        <PreviewChart
          chartID={chartId}
          metrics={metrics}
          key={chartId}
          isLoading={isLoading}
          series={series}
          categories={[]}
          startDate={selectedDate}
          primaryGranularity={"raw"}
          visibleSeries={series.map(data => true)}
          zoomResetViewRef={zoomResetViewRef}
          onZoom={onZoom}
          onZoomReset={onZoomReset}
          zoomedRange={zoomedRange}
          setLoading={setLoading}
          isZoomed={isZoomed}
          annotationData={annotationData}
        />
      </Box>
      <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
        <PrimaryFormLoadingActionButton
          onClick={onSave}
          disabled={isSaveDisabled}
        >
          {isEdit ? 'Save' : 'Create'}
        </PrimaryFormLoadingActionButton>
      </Box>
    </Box>
  );
};

export default VisualizationPreview;
